module.exports = __webpack_public_path__ + "static/media/coinsTransfer_1.12d8b2ae.mp3";